import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Stack, Typography, styled } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";

import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import {
 fetchCampaignsData,
 handleCampainIDSelection,
 resetSubmissionButton,
} from "../Redux/Mailer";
import { handleGenerateTeaser, handleTeaserLoading } from "../Redux/Teaser";
import TeaserDataDisplay from "./TeaserDataDisplay";
const CustomRadio = styled(Radio)(({ theme }) => ({
 "&.Mui-checked": {
  color: "#9c27b0", // Purple for the checked state
 },
 "& .MuiSvgIcon-root": {
  fontSize: "1.5rem", // Custom icon size
 },
 "&:hover": {
  backgroundColor: "rgba(156, 39, 176, 0.08)", // Optional hover effect
 },
}));
const WhiteBorderTextField = styled(TextField)`
 & label.Mui-focused {
  color: #a804ff;
 }
 & .MuiOutlinedInput-root {
  &.Mui-focused fieldset {
   border-color: #a814ff;
   border-width: 1px;
  }
 }
`;

const TeaserForm = ({
  programList,
 categoryNameTeaser,
 setCategoryNameTeaser,
 mailerChild,
 mailerParent,
 setMailerParent,
 setMailerChild,
}) => {
 const [subjectLineTeaser, setSubjectLineTeaser] = useState("");
 const [programNameTeaser, setProgramNameTeaser] = useState("");
 const [teaserMessage, setTeaserMessage] = useState("");
 const [keyDateTeaser, setKeyDateTeaser] = useState("");
 const [isTeaserMailGenerated, setIsTeaserMailGenerated] = useState("init");
 const [isTeaserNavigatedToForm, setIsTeaserNavigatedToForm] = useState(false);
 const [campaign, setCampaign] = useState(0);
 const campaignList = useSelector((state) => state.model.campaignList);
 const options =
  campaignList.message !== "No campaign for this user." && campaignList.length > 0
   ? campaignList.map((item) => ({ id: item.id, name: item.name }))
   : [];
 const today = new Date().toISOString().split("T")[0];
 const dispatch = useDispatch();
 const [value, setValue] = React.useState(null);

 useEffect(() => {
  dispatch(fetchCampaignsData(categoryNameTeaser));
 }, []);
 const handleChange = (event) => {
  if (event.target.value == "no") {
   setCampaign(0);
   dispatch(handleCampainIDSelection(0));
  }
  setProgramNameTeaser("");
  setKeyDateTeaser("");
  setTeaserMessage("");

  setIsTeaserMailGenerated("init");
  setIsTeaserNavigatedToForm(false);
  setValue(event.target.value);
 };
 const [isTeaserMailGenerationClicked, setIsTeaserMailGenerationClicked] =
  React.useState(false);

 const handleRadioChange = (e) => {
  setCategoryNameTeaser(e.target.value);
  dispatch(fetchCampaignsData(e.target.value));
  setKeyDateTeaser("");
  setTeaserMessage("");
  dispatch(resetSubmissionButton());
  setIsTeaserMailGenerated("init");
  setIsTeaserNavigatedToForm(false);
  setProgramNameTeaser("");
  setCampaign(0);
  setValue("");
 };
 const handleCampaignID = (val) => {
  if (val) {
   setCampaign(val.id);
   let campaignID = val.id;
   let data = campaignList.filter((val) => val.id == campaignID);
   setProgramNameTeaser(data[0].name);

   const item = data[0].selectedItems.filter(
    (val) => val.title == "Learning Journey Start"
   );
   let initialDate;
   if (item.length != 0) {
    initialDate = format(parseISO(item[0].date), "yyyy-MM-dd");
   } else {
    initialDate = "";
   }
   setKeyDateTeaser(initialDate);
   dispatch(handleCampainIDSelection(campaignID));
  }
 };

 const handleReset = () => {
  setKeyDateTeaser("");
  setTeaserMessage("");
  dispatch(resetSubmissionButton());
  setMailerChild("");
  setMailerParent("");
  setProgramNameTeaser("");
  setCategoryNameTeaser("Program");
 };
 const handleTeaserMailGeneration = () => {
  setIsTeaserMailGenerationClicked(true);
  let values = {
   teaserMessage: teaserMessage,
   keyDateTeaser: keyDateTeaser,
   currentContent: "",
   sessionID: localStorage.getItem("sessionId"),

   categoryName: categoryNameTeaser,
  };
  dispatch(handleGenerateTeaser(values));
 };
 const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
 ))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
   backgroundColor: "#f5f5f9",
   color: "rgba(0, 0, 0, 0.87)",
   maxWidth: 220,
   fontSize: theme.typography.pxToRem(12),
   border: "1px solid #dadde9",
  },
 }));
 const ITEM_HEIGHT = 48;
 const ITEM_PADDING_TOP = 8;
 const MenuProps = {
  PaperProps: {
   style: {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 200,
   },
  },
 };
 return (
  <>
   {!isTeaserMailGenerationClicked ? (
    <Stack>
     <Stack sx={{ width: "100%" }}>
      <WelcomeNameContainer currentComp="Teaser" />
      <Stack spacing={1} className="mail-form-container-stack">
       <div className="mail-form-container">
        <div className="mailer-form-categories-section">
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Learning Program</span>
          <input
           type="radio"
           checked={categoryNameTeaser === "Program"}
           value="Program"
           name="radio-category"
           onChange={handleRadioChange}
          />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Event</span>
          <input
           type="radio"
           checked={categoryNameTeaser === "Event"}
           value="Event"
           name="radio-category"
           onChange={handleRadioChange}
          />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Microsite/Tool/Platform</span>
          <input
           type="radio"
           checked={categoryNameTeaser === "Microsite/Tool/Platform"}
           value="Microsite/Tool/Platform"
           name="radio-category"
           onChange={handleRadioChange}
          />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Webinar</span>
          <input
           type="radio"
           checked={categoryNameTeaser === "Webinar"}
           value="Webinar"
           name="radio-category"
           onChange={handleRadioChange}
          />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
        </div>
        <Stack direction={"row"} sx={{ alignItems: "flex-start" }} spacing={2}>
         <Stack direction={"row"} sx={{ alignItems: "flex-start" }} spacing={2}>
          <Stack direction={"column"}>
           <Typography>
            Is this communication part of any campaign?
            <span style={{ color: "red" }}>*</span>
           </Typography>
           <Typography>(If yes, select the campaign name)</Typography>
          </Stack>

          <FormControl>
           <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={value}
            onChange={handleChange}
            sx={{ paddingLeft: "20px" }}
           >
            <FormControlLabel
             value="yes"
             control={
              <CustomRadio
               icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
               checkedIcon={
                <CheckCircleOutlineIcon
                 style={{ fontSize: "1.3rem", color: "#9c27b0" }}
                />
               } // Checkmark inside circle when checked
              />
             }
             label="Yes"
            />
            <FormControlLabel
             value="no"
             control={
              <CustomRadio
               icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
               checkedIcon={
                <CheckCircleOutlineIcon
                 style={{ fontSize: "1.3rem", color: "#9c27b0" }}
                />
               } // Checkmark inside circle when checked
              />
             }
             label="No"
            />
           </RadioGroup>
          </FormControl>
         </Stack>
         {value == "yes" && (
          <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
           <Typography>
            Select the campaign <span style={{ color: "red" }}>*</span>
           </Typography>
           <Stack
            className="mail-form-headers"
            sx={{
             display: "flex",
             flexDirection: "column",
             gap: "10px",
             marginBottom: "10px",
             m: 1,
             width: 200,
             mt: 3,
            }}
            direction={"row"}
            spacing={2}
           >

            <Autocomplete
             value={options.find((option) => option.id === campaign) || null}
             onChange={(event, newValue) => {
              handleCampaignID(newValue);
             }}
             options={options}
             getOptionLabel={(option) => option.name || ""}
             ListboxProps={{
              style: {
               maxHeight: "150px", // Fixed height for the dropdown
               overflowY: "auto", // Enable vertical scrolling
              },
             }}
             renderInput={(params) => (
              <TextField
               sx={{ "& .MuiOutlinedInput-root": { padding: "2px !important" } }}
               {...params}
               variant="outlined"
              />
             )}
             filterSelectedOptions={false}
            />
           </Stack>
          </Stack>
         )}
        </Stack>
        <div className="mail-form-wrap">
         <div className="mail-form-inner-wrap"></div>
         <div className="mail-form-inner-wrap"></div>

         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontSize: "16px" }}>
           <span>
            Name<span style={{ color: "red" }}>*</span>
           </span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              {categoryNameTeaser == "Program" ? (
               <p> Enter the program name </p>
              ) : categoryNameTeaser == "Event" ? (
               <p> Enter the event name</p>
              ) : categoryNameTeaser == "Microsite/Tool/Platform" ? (
               <p> Enter the Microsite/Tool/Platform name</p>
              ) : (
               <p> Enter the Webinar name</p>
              )}
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "3%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>
            <Autocomplete
            id="free-solo-demo"
            freeSolo
            value={programNameTeaser}
            onChange={(event, newValue) => {
              setProgramNameTeaser(newValue || ""); // Ensure value updates when selecting a suggestion
              setIsTeaserMailGenerated("init");
            }}
            onInputChange={(event, newInputValue) => {
              setProgramNameTeaser(newInputValue); // Update state when typing
            }}
            disabled={!value || (value === "yes")}
            inputprops={{ readOnly: value === "yes"}}
            options={programList.map((option) => option.programname)}
            renderInput={(params) => (
              <WhiteBorderTextField
                {...params}
                id="multiline"
                multiline
                minRows={1}
                maxRows={2}
                fullWidth
                placeholder={
                  categoryNameTeaser === "Program"
                    ? "e.g: Java Full Stack"
                    : categoryNameTeaser === "Event"
                    ? "e.g: ATCI Event"
                    : categoryNameTeaser === "Microsite/Tool/Platform"
                    ? "e.g: ATCI Learning"
                    : "e.g: ATCI Webinar"
                }
                disabled={!value || (value === "yes" && campaign === 0)} 
              />
            )}
          />

         </Stack>
         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontSize: "16px" }}>
           <span>Key Date</span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              {categoryNameTeaser == "Program" ? (
               <p> Select program launch date. </p>
              ) : categoryNameTeaser == "Event" ? (
               <p> Select event launch date.</p>
              ) : categoryNameTeaser == "Microsite/Tool/Platform" ? (
               <p> Select Microsite/Tool/Platform launch date.</p>
              ) : (
               <p> Select webinar launch date.</p>
              )}
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "3%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>
          <input
           type="date"
           className="maindate"
           min={today}
           style={{ padding: "11px" }}
           disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
           readOnly={
            value == "yes" && campaign != 0 && keyDateTeaser != "" ? true : false
           }
           onChange={(event) => {
            setKeyDateTeaser(event.target.value);
            setIsTeaserMailGenerated("init");
           }}
           value={keyDateTeaser}
           onKeyDown={(e) => e.preventDefault()}
          />
         </Stack>
         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontSize: "16px" }}>
           <span>Teaser Message</span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              <p>Write a short, intriguing message</p>
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "3%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField
           placeholder={
            categoryNameTeaser == "Program"
             ? "e.g: Get ready for a game-changer in learning!"
             : categoryNameTeaser == "Event"
             ? "e.g: Get ready for a game-changer in event!"
             : categoryNameTeaser == "Microsite/Tool/Platform"
             ? "e.g: Get ready for a game-changer in Microsite/Tool/Platform!"
             : "e.g: Get ready for a game-changer in webinar!"
           }
           id="multiline"
           multiline
           InputLabelProps={{ shrink: false }}
           disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
           minRows={3}
           //   maxRows={2}
           onChange={(event) => {
            setTeaserMessage(event.target.value);
            setIsTeaserMailGenerated("init");
           }}
           fullWidth
           value={teaserMessage}
          />
         </Stack>
        </div>
       </div>
       <div className="btn-container">
        {isTeaserNavigatedToForm && (
         <button
          className="reset-btn"
          onClick={() => {
           setIsTeaserMailGenerated("generateOutput");
           setIsTeaserMailGenerationClicked(true);
          }}
         >
          Next
         </button>
        )}

        {isTeaserMailGenerated == "init" && programNameTeaser !== "" ? (
         <div
          className="mailer-generate-btn"
          onClick={() => {
           handleTeaserMailGeneration();
           setIsTeaserMailGenerated("generateOutput");
           dispatch(handleTeaserLoading());
          }}
         >
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div>
        ) : (
         <div className="mailer-generate-btn-disable">
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div>
        )}
        {/* )} */}
       </div>
      </Stack>
     </Stack>
    </Stack>
   ) : isTeaserMailGenerated == "generateOutput" ? (
    <>
     <TeaserDataDisplay
      setIsTeaserMailGenerationClicked={setIsTeaserMailGenerationClicked}
      categoryNameTeaser={categoryNameTeaser}
      mailerChild={mailerChild}
      mailerParent={mailerParent}
      handleReset={handleReset}
      setIsTeaserNavigatedToForm={setIsTeaserNavigatedToForm}
      setIsTeaserMailGenerated={setIsTeaserMailGenerated}
      programNameTeaser={programNameTeaser}
     />
    </>
   ) : (
    <></>
   )}
  </>
 );
};

export default TeaserForm;
